<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {},
  created() {
    let windowWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
    let baseUrl = window.location.protocol + '//' + window.location.hostname;
    let mobileQuery = this.$route.meta.mobileQuery ? this.$route.meta.mobileQuery : {};
    let query = '?';

    let queryObj = {
      ...mobileQuery,
      ...this.$route.query
    };
    for (let key in queryObj) {
      query += (key + '=' + queryObj[key] + '&');
    }
    query = query.substr(0, query.length - 1);
    // if (windowWidth < 720) {
    //   window.open(baseUrl + '/m/index.html#/', '_self')
    // }
  }
}
</script>

<style lang="less">
@import url("../node_modules/element-ui/lib/theme-chalk/index.css");
@import url("../node_modules/quill/dist/quill.core.css");
// import styles
@import url("../node_modules/quill/dist/quill.snow.css");
// for snow theme
@import url("../node_modules/quill/dist/quill.bubble.css"); // for bubble theme
/////////////////////////////////////////////////////reset start
html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, dl, dt, dd, ol, ul, li, fieldset, form, button, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  box-sizing: border-box;
}

body {
  line-height: 1;
}

:focus {
  //outline: 1;
}

article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary {
  display: block;
}

ul, ol, li {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after, q:before, q:after {
  content: "";
  content: none;
}

a {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  color: inherit;

  &:visited {
    color: inherit;
  }

  &:hover {
    color: inherit;
    text-decoration: underline;
  }

  &:active {
    color: inherit;
    text-decoration: none;
  }
}

ins {
  background-color: #FF9;
  color: #000;
  text-decoration: none;
}

mark {
  background-color: #FF9;
  color: #000;
  font-style: italic;
  font-weight: bold;
}

del {
  text-decoration: line-through;
}

abbr[title], dfn[title] {
  border-bottom: 1px dotted #000;
  cursor: help;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #CCC;
  margin: 1em 0;
  padding: 0;
}

button {
  cursor: pointer;
  font-family: inherit;
}

input, select {
  vertical-align: middle;
}

textarea {
  outline: none;
  background: none;
}

input {
  outline: none;
  background: none;
  box-sizing: border-box;

  &::-ms-clear,
  &::-ms-reveal {
    display: none;
  }

  &[type="text"]:focus,
  &[type="password"]:focus {

    border: 1px solid #EB7350;

    background: #FFF;

    outline: none;

  }
}

.format-error-sign {
  display: none;
}

.format-error {
  border: 1px solid @color-error !important;
  position: relative;

  & + .format-error-sign {
    display: inline;
    .color(@color-error);
    .fz(14px);
    padding-left: 10px;
  }
}

i, .icon {
  display: inline-block;
  vertical-align: middle;
}

/////////////////////////////////////////////////////////////////////reset end

body {
  height: 100%;

  .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .el-select-dropdown .el-scrollbar {
    padding-bottom: 17px;
  }

  #app {
    height: 100%;
    font-family: "Microsoft YaHei", "微软雅黑", "宋体", "黑体", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    .color(#2C3E50);

    /*margin-top: 60px;*/

    #container {
      .height();

      #wrapper {
        .min-height(100%);

        .search-result-pagination {
          .fr;
          padding: 0;

          .btn-prev, .btn-next {
            .size(79px, 36px);
            .fz(14px) !important;
            .color(#252627) !important;
            background-color: #FFF !important;
            border: 1px solid #EBEBEB !important;

            &:disabled {
              .color(#C0C4CC) !important;
            }
          }

          .el-pager {
            li {
              .min-width(36px) !important;
              .lh(36px);
              .fz(20px);
              .color(#888) !important;
              font-weight: lighter;
              .border-radius(4px) !important;
              background-color: #FFF !important;
              border: 1px solid #EBEBEB !important;

              &.active {
                background-color: @main-color !important;
                .color(#FFF) !important;
              }

              &.el-icon-more {
                border: none !important;

                &.btn-quicknext, &.btn-quicknext + li {
                  display: none !important;
                }
              }

              &.el-icon-d-arrow-right, &.el-icon-d-arrow-left {
                border: none !important;
                .color(@main-color) !important;
              }
            }
          }
        }
      }
    }
  }
}

.high-light {
  color: red;
}

@import 'tailwind.css';
</style>
